import { all } from 'redux-saga/effects';
import authSagas from '@iso/redux/auth/saga';
import appSagas from '@iso/redux/app/sagas';

export default function* rootSaga() {
  yield all([authSagas(), appSagas()]);
}
